// extracted by mini-css-extract-plugin
export default {"button":"Rl-z","reviewSort":"Sl-z"};